import React from 'react';
import '../css/NewsUpdates.css';

const NewsUpdates = () => {
    const primaryDate = 'August 21, 2024';
    const primaryTime = 'STCJMIS Inaugurates New Building';
    const secondaryDate = 'August 10, 2024';
    const secondaryHeadline = 'STCJMIS PSHSH Qualifiers';
    const tertiaryDate = 'July 31, 2024';
    const tertiaryHeadline = 'STCJMIS Celebrates Nutrition Month';

    return (
        <div className='newsupdates-container'>
            <div className='flex-center'>
                {/* LEFT PANE */}
                <div className='left-pane'>
                    <div className='image primary-news cursor-pointer subtle-shadow'/>  {/* ASPECT RATIO 4:3*/}
                    <div className='primary-text'>
                        <div className='secondary-white-text date'>{primaryDate}</div>
                        <div className='secondary-white-text bold'>{primaryTime}</div>
                    </div>
                </div>
                {/* RIGHT PANE */}
                <div className='right-pane'>
                    <div className='right-pane-image-text flex-center'>
                        <div className='image secondary-news cursor-pointer subtle-shadow' />  {/* ASPECT RATIO 4:3*/}
                        <div className='right-pane-text'>
                            <div className='secondary-white-text date'>{secondaryDate}</div>
                            <div className='secondary-white-text bold'>{secondaryHeadline}</div>
                        </div>
                    </div>
                    <div className='right-pane-image-text flex-center'>
                        <div className='image secondary-news cursor-pointer subtle-shadow' />  {/* ASPECT RATIO 4:3*/}
                        <div className='right-pane-text outline'>
                            <div className='secondary-white-text date'>{tertiaryDate}</div>
                            <div className='secondary-white-text bold'>{tertiaryHeadline}</div>
                        </div>
                    </div>
                </div>
            </div>
            {/* READ MORE */}
            <div className='button-container'>
                <div className='button-click-more secondary-yellow-background'>Read More</div>
            </div>
            
        </div>
    );
};

export default NewsUpdates;